module.exports = __webpack_public_path__ + "static/media/header-2.7e617f9a.jpg";